/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for RDS database password management during restore. 
*/
export class RdsPasswordConfig {
  /**
  * Password management type for the restored database. 
  */
  'passwordManagementType'?: RdsPasswordConfigPasswordManagementTypeEnum;
  /**
  * Customer-managed password (required when passwordManagementType is SELF_MANAGED). 
  */
  'password'?: string;
  /**
  * KMS key ARN used to encrypt the Secrets Manager secret that stores the database master password. Only applicable when passwordManagementType is AWS_SECRETS_MANAGER. This is distinct from encryptionKeyId which controls RDS storage encryption. 
  */
  'secretsManagerKmsKeyId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "passwordManagementType",
      "baseName": "passwordManagementType",
      "type": "RdsPasswordConfigPasswordManagementTypeEnum",
      "format": ""
    },
    {
      "name": "password",
      "baseName": "password",
      "type": "string",
      "format": ""
    },
    {
      "name": "secretsManagerKmsKeyId",
      "baseName": "secretsManagerKmsKeyId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RdsPasswordConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum RdsPasswordConfigPasswordManagementTypeEnum {
  AwsSecretsManager = 'AWS_SECRETS_MANAGER',
  SelfManaged = 'SELF_MANAGED'
}

